<template>
  <div>
    <section class="form-section">
      <div
        v-if="!requisicaoFinalizada"
        class="flex items-center justify-center"
        style="min-height: 300px"
      >
        <div
          style="
            border: 4px solid #e5e7eb;
            border-top: 4px solid #00235c;
            border-radius: 50%;
            width: 50px;
            height: 50px;
            animation: spin 1s linear infinite;
          "
        ></div>
      </div>

      <div v-if="requisicaoFinalizada">
        <div class="form-section-header">
          <div class="flex items-start justify-between">
            <div class="flex-1">
              <h4
                class="text-sm font-semibold text-gray-900 dark:text-gray-100 mb-2"
              >
                Termos de assinatura
              </h4>
              <p class="text-sm text-gray-600 dark:text-gray-400">
                Aqui estão todos os documentos disponíveis para o seu perfil,
                clicar em ler os termos e aceitar as regras estabelecidas.
              </p>

              <!-- Slot opcional para conteúdo adicional no cabeçalho (ex.: LabelDisclaimer) -->
              <slot name="header-extra"></slot>
            </div>
          </div>
        </div>

        <div v-if="requisicaoFinalizada" class="form-section-content">
          <div
            v-if="!listaDocumentos || listaDocumentos.length === 0"
            class="text-center py-8"
          >
            <p class="text-gray-500 dark:text-gray-400">
              Nenhum documento encontrado
            </p>
          </div>

          <div v-if="listaDocumentos && listaDocumentos.length > 0">
            <!-- Grid Desktop -->
            <div class="hidden md:block overflow-x-auto">
              <table
                class="min-w-full divide-y divide-gray-200 dark:divide-gray-700"
              >
                <thead class="bg-gray-50 dark:bg-gray-800">
                  <tr>
                    <th
                      class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                    >
                      Nome do documento
                    </th>
                    <th
                      class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                    >
                      Ações
                    </th>
                  </tr>
                </thead>
                <tbody
                  class="bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700"
                >
                  <tr
                    v-for="(documentoObj, index) in documentosFiltrados"
                    :key="index"
                    class="hover:bg-gray-50 dark:hover:bg-gray-800"
                  >
                    <td class="px-6 py-4 text-sm text-gray-900 dark:text-gray-100">
                      <div class="flex items-center gap-2">
                        <span class="whitespace-nowrap">{{ nomeDocumentoSemSufixo(documentoObj) }}</span>
                        <span
                          v-if="documentoObrigatorio(documentoObj)"
                          class="inline-flex items-center whitespace-nowrap px-2 py-0.5 rounded-full text-xs font-medium bg-red-50 text-red-700 border border-red-200 dark:bg-red-900/30 dark:text-red-300 dark:border-red-700/60"
                        >
                          Obrigatório
                        </span>
                      </div>
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm">
                      <div class="flex flex-wrap gap-2">
                        <button
                          v-if="
                            !documentosCliente.some(
                              (p) => p.TemplateId === documentoObj.TemplateId,
                            )
                          "
                          @click="abrirTermos(documentoObj.TemplateId)"
                          class="btn-primary text-xs"
                        >
                          Ler o termo
                        </button>

                        <button
                          v-if="
                            documentoAssinadoSemPendencia(
                              documentoObj.TemplateId,
                            )
                          "
                          disabled
                          class="btn-primary text-xs opacity-75 cursor-not-allowed"
                        >
                          Termo aceito
                        </button>

                        <button
                          v-if="
                            documentoAssinadoSemPendencia(
                              documentoObj.TemplateId,
                            )
                          "
                          @click="lerTermos(documentoObj.TemplateId)"
                          class="btn-secondary text-xs"
                        >
                          Ver termo
                        </button>

                        <button
                          v-if="
                            showStatusButton &&
                            existeAssinaturaPendente(documentoObj.TemplateId)
                          "
                          @click="statusAssinatura(documentoObj.TemplateId)"
                          class="btn-secondary text-xs"
                        >
                          Status da Assinatura
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Grid Mobile -->
            <div class="block md:hidden space-y-4">
              <div
                v-for="(documentoObj, index) in documentosFiltrados"
                :key="'m-' + index"
              >
                <div
                  v-if="documentoObj.NomeDocumento"
                  class="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg p-4 shadow-sm"
                >
                  <div class="mb-3">
                    <div class="flex items-start gap-2 mb-2">
                      <p class="font-semibold text-gray-900 dark:text-gray-100">
                        {{ nomeDocumentoSemSufixo(documentoObj) }}
                      </p>
                      <span
                        v-if="documentoObrigatorio(documentoObj)"
                        class="inline-flex items-center whitespace-nowrap px-2 py-0.5 rounded-full text-xs font-medium bg-red-50 text-red-700 border border-red-200 dark:bg-red-900/30 dark:text-red-300 dark:border-red-700/60"
                      >
                        Obrigatório
                      </span>
                    </div>
                    <div class="flex items-center gap-2 text-sm">
                      <span class="text-gray-600 dark:text-gray-400"
                        >Situação:</span
                      >
                      <span
                        :class="
                          documentoAssinadoSemPendencia(documentoObj.TemplateId)
                            ? 'text-green-600 dark:text-green-400'
                            : 'text-yellow-600 dark:text-yellow-400'
                        "
                      >
                        {{
                          documentoAssinadoSemPendencia(documentoObj.TemplateId)
                            ? "Assinado"
                            : "Pendente"
                        }}
                      </span>
                    </div>
                  </div>

                  <div class="flex flex-wrap gap-2">
                    <button
                      v-if="
                        !documentosCliente.some(
                          (p) => p.TemplateId === documentoObj.TemplateId,
                        )
                      "
                      @click="abrirTermos(documentoObj.TemplateId)"
                      class="btn-primary text-xs"
                    >
                      Ler o termo
                    </button>
                    <button
                      v-if="
                        documentosCliente.some(
                          (p) => p.TemplateId === documentoObj.TemplateId,
                        )
                      "
                      @click="lerTermos(documentoObj.TemplateId)"
                      class="btn-secondary text-xs"
                    >
                      Ver termo
                    </button>
                    <button
                      v-if="
                        showStatusButton &&
                        existeAssinaturaPendente(documentoObj.TemplateId)
                      "
                      @click="statusAssinatura(documentoObj.TemplateId)"
                      class="btn-secondary text-xs"
                    >
                      Status da Assinatura
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Slot para injetar modais específicos, se necessário (ex.: PJ) -->
    <slot name="modals"></slot>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "DeclaracoesDocumentosList",
  components: {},
  props: {
    tipoClienteKey: { type: String, required: true },
    showStatusButton: { type: Boolean, default: false },
    showRefresh: { type: Boolean, default: false },
    useImpressaoFlag: { type: Boolean, default: false },
    searchPlaceholder: { type: String, default: "Pesquisar" },
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      listaDocumentos: "GET_LISTA_DOCUMENTOS",
      listaDocumentosCliente: "GET_LISTA_DOCUMENTOS_CLIENTE",
    }),
    documentosFiltrados() {
      if (!this.listaDocumentos) return [];
      if (this.filtroDocumento === "") {
        return this.listaDocumentos.filter((doc) =>
          (doc.TipoCliente || "")
            .toLowerCase()
            .includes(this.tipoClienteKey.toLowerCase()),
        );
      }
      if (this.filtroDocumento.length > 0) {
        return this.listaDocumentos.filter(
          (doc) =>
            (doc.NomeDocumento || "")
              .toLowerCase()
              .includes(this.filtroDocumento.toLowerCase()) &&
            (doc.TipoCliente || "")
              .toLowerCase()
              .includes(this.tipoClienteKey.toLowerCase()),
        );
      }
      return this.listaDocumentos;
    },
  },
  data() {
    return {
      filtroDocumento: "",
      documentosCliente: [],
      requisicaoFinalizada: false,
    };
  },
  async created() {
    await this.$store.dispatch("FETCH_CONSULTA_LISTA_DOCUMENTOS");
  },
  async mounted() {
    await this.$store.dispatch("INIT_DECLARACAO_SIGNALR");
  },
  beforeUnmount() {
    this.$store.dispatch("DESTROY_DECLARACAO_SIGNALR");
  },
  watch: {
    listaDocumentos() {
      if (
        this.listaDocumentos &&
        this.listaDocumentos.some((a) => a.AlterouVersaoComAssinatura == true)
      ) {
        this.$alert({
          icon: "warning",
          title: "Atenção: Precisamos de uma nova assinatura",
          text: "Houve uma atualização nas declarações. Para seguir com seu cadastro, pedimos que reenvie novamente o documento para os responsáveis.",
        });
      }
    },
    listaDocumentosCliente() {
      this.requisicaoFinalizada = true;
      if (this.listaDocumentosCliente) {
        this.documentosCliente = this.listaDocumentosCliente;
      }
    },
  },
  methods: {
    pesquisarDocumento() {},
    async atualizarGridDeclaracoes() {
      if (!this.showRefresh) return;
      this.requisicaoFinalizada = false;
      await this.$store.dispatch("FETCH_CONSULTA_LISTA_DOCUMENTOS_CLIENTE");
    },
    async verificarMotivoDocumentoPendente() {
      await this.$store.dispatch("FETCH_CONSULTA_DOCUMENTO_VERSAO");
    },
    abrirTermos(id) {
      this.$store.commit("SET_MODAL_TERMOS_DOCUMENTOS", id);
      this.$store.commit("SET_MODAL_TERMOS_DOCUMENTOS_BLOQUEAR_ACEITE", false);
      if (this.useImpressaoFlag) {
        // No abrirTermos, impressão não é habilitada
        this.$store.commit("SET_MODAL_TERMOS_DOCUMENTOS_IMPRESSAO", false);
      }
    },
    lerTermos(id) {
      const habImpressao =
        this.useImpressaoFlag && this.existeAssinaturaPendente(id);
      this.$store.commit("SET_MODAL_TERMOS_DOCUMENTOS", id);
      if (this.useImpressaoFlag) {
        this.$store.commit(
          "SET_MODAL_TERMOS_DOCUMENTOS_IMPRESSAO",
          !!habImpressao,
        );
      }
      this.$store.commit("SET_MODAL_TERMOS_DOCUMENTOS_BLOQUEAR_ACEITE", true);
    },
    statusAssinatura(id) {
      const obj = this.documentosCliente.filter(
        (p) => p.TemplateId === id && p.StatusAssinatura == "Pendente",
      )[0];
      if (obj && obj.DeclaracaoGuid) {
        this.$store.commit("SET_MODAL_ASSINATURA_STATUS", obj.DeclaracaoGuid);
      }
    },
    documentoAssinadoSemPendencia(templateId) {
      const hasTemplate = this.documentosCliente.some(
        (p) => p.TemplateId == templateId,
      );
      const hasPending = this.documentosCliente.some(
        (p) => p.TemplateId == templateId && p.StatusAssinatura == "Pendente",
      );
      return hasTemplate && !hasPending;
    },
    existeAssinaturaPendente(templateId) {
      return this.documentosCliente.some(
        (p) => p.TemplateId === templateId && p.StatusAssinatura == "Pendente",
      );
    },
    nomeDocumentoSemSufixo(doc) {
      const nome = (doc && doc.NomeDocumento) || "";
      return nome.replace(/\s*\[\s*obrigat[oó]ri[oa]\s*\]\s*$/i, "").trim();
    },
    documentoObrigatorio(doc) {
      if (!doc) return false;
      const valor =
        doc.Obrigatoriedade ?? doc.Obrigatorio ?? doc.ObrigatorioDocumento;
      if (valor === true) return true;
      if (valor === false || valor == null) return false;
      return ["sim", "s", "true", "1"].includes(
        String(valor).trim().toLowerCase(),
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap");

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
